/**
 * @generated SignedSource<<0eb1296dfa903d3fbcc287452903fa16>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AIStudioTaskState = "COMPLETED" | "ERROR" | "NO_CREDITS" | "PROCESSING" | "WAITING";
export type MagicSwapInput = {
  colorImageUrl?: string | null;
  colorPreset?: string | null;
  customPrompt?: string | null;
  effectPreset?: string | null;
  materialImageUrl?: string | null;
  materialPreset?: string | null;
  productImageUrl: string;
  saveToLibrary: boolean;
  targetArea?: string | null;
};
export type tasksStartMagicSwapMutation$variables = {
  input: MagicSwapInput;
};
export type tasksStartMagicSwapMutation$data = {
  readonly startMagicSwap: {
    readonly createdAt: string;
    readonly state: AIStudioTaskState;
    readonly taskId: number;
  };
};
export type tasksStartMagicSwapMutation = {
  response: tasksStartMagicSwapMutation$data;
  variables: tasksStartMagicSwapMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MagicSwapTask",
    "kind": "LinkedField",
    "name": "startMagicSwap",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "tasksStartMagicSwapMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "tasksStartMagicSwapMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "da1eac41bc628e2fa071b7e30b04b430",
    "id": null,
    "metadata": {},
    "name": "tasksStartMagicSwapMutation",
    "operationKind": "mutation",
    "text": "mutation tasksStartMagicSwapMutation(\n  $input: MagicSwapInput!\n) {\n  startMagicSwap(input: $input) {\n    taskId\n    state\n    createdAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "58af6260080d43dd815b56e68259e7cd";

export default node;
